import React from 'react';

import {
    Row,
    Col,
    Jumbotron
} from 'reactstrap';

import Page from "../components/Page";
import {MdViewModule} from "react-icons/lib/md";

class DashboardPage extends React.Component {
    componentDidMount() {
        // this is needed, because InfiniteCalendar forces window scroll
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <Page
                className="DashboardPage"
                title="Dashboard"
                icon="MdViewModule"
                // breadcrumbs={[{name: 'Dashboard', active: true}]}
            >
                <Row>
                    <Col>
                        <Jumbotron>
                            <h1 className="display-3">Bem vindo!</h1>
                            <p className="lead">
                                Este é o painel do GEIN, aqui você conseguirá gerenciar todos as suas informações.
                            </p>
                        </Jumbotron>
                    </Col>
                </Row>
            </Page>
        );
    }
}

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.js